<template>
  <teleport to="body">
    <transition name="shuffle" appear @after-leave="onAfterLeave">
      <div v-if="visible" class="modal-wrapper">
        <div class="overlay" @click="onRequestClose"></div>
        <div class="modal">
          <component :is="component" v-bind="$attrs" @close="onRequestClose" />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'ApplicationModal',
  props: {
    component: {
      type: [Object, Function],
      default: undefined
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    onRequestClose() {
      this.visible = false;
    },
    onAfterLeave() {
      const parts = this.$route.fullPath.split('/');
      const returnPath = `/${parts[1]}/${parts[2]}`;
      this.$router.push({ path: returnPath });
    }
  }
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none;
}

.overlay {
  position: fixed;
  background-color: #000;
  pointer-events: auto;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.modal {
  pointer-events: auto;
}
</style>
